export default [
  {
    title: 'Zum Umgang mit Fluchterfahrungen',
    items: [
      {
        type: 'pdf',
        body: 'Hinweis, welche LEs weggelassen/abgeändert werden könnten, sofern Fluchterfahrungen in der Klasse vorhanden sind.',
        url: [
          '/downloads/Merkblatt-1_Besonderheiten_in_der_schulischen_Arbeit_mit_Kindern_mit_Fluchterfahrung.pdf',
          '/downloads/Merkblatt-2_Arbeiten_mit_traumatisierten_Kindern.pdf',
        ],
      },
    ],
  },
  {
    title: 'Zum Thema Zeitzeugengespr&auml;che',
    items: [
      {
        type: 'pdf',
        body: 'Kontakt zum Koordinierenden Zeitzeugenbüro (KZB) für Zeitzeugengespräche, die vermittelt und finanziert werden können',
        url: 'http://www.zeitzeugenbuero.de/fileadmin/zzp/pdf/Finanzierung_und_Abrechnung_von_Zeitzeugengespr%C3%A4chen_in_Schulen.pdf',
      },
      {
        type: 'link',
        body: 'Lehrer-Leitfaden zur Durchführung von Zeitzeugengesprächen',
        url: 'https://www.bundesstiftung-aufarbeitung.de/forschung%2C-lehre-und-bildung-foerdern-2475.html?PAGE=artikel_detail&artikel_id=351',
      },
      {
        type: 'pdf',
        body: 'Zeitzeugenbroschüre von CARE',
        url: '/downloads/care-zeitzeugenbroschuere-web.pdf',
      },
      {
        type: 'video',
        body: 'Informationen über Stasi und Zeitzeuge Hartmut Rosinger (ex-IM) im Film „Feindberührung“',
        url: 'http://www.feindberuehrungfilm.de/',
      },
    ],
  },
  {
    title: 'Quellmaterial f&uuml;r weitere Aufgaben',
    items: [
      {
        type: 'link',
        body: 'Zur besseren Visualisierung von historischen Ereignissen, können Sie Ihren Zeitstrahl mit zeitgenössischen Bildern ergänzen. Bilder finden Sie online im Münchner Digitalisierungszentrum',
        url: 'https://www.digitale-sammlungen.de/index.html?c=startseite&l=de',
      },
    ],
  },
  {
    title: 'Weiterf&uuml;hrende Unterrichtsmaterialien',
    items: [
      {
        type: 'link',
        body: 'Für die Vertiefung des Themas Freizügigkeit und Mobilität in Europa: Unterrichtsmaterial: „Sophie und Paul entdecken Europa“',
        url: 'https://publications.europa.eu/de/publication-detail/-/publication/e05d8afe-03da-11e7-8a35-01aa75ed71a1',
      },
      {
        type: 'pdf',
        body: 'Zur Vertiefung des Themas Grundrechte und Kinderrechte: Übungen bei CARE(KIWI 2.1.1.: Wertepyramide; 2.4.1. Menschenrechte; 2.1.5. Kinderrechte, „Hänsel und Gretel“-Geschichte als STOP-Spiel)',
        url: [
          '/downloads/2.1.1.Wertepyramide.pdf',
          '/downloads/2.1.5.Kinderrechte.pdf',
          '/downloads/2.4.1.Menschenrechte.pdf',
          '/downloads/2.4.1.Menschenrechte+Erklärung.pdf',
        ],
      },
      {
        type: 'pdf',
        body: 'Der Volksaufstand vom Juni 1953 kann SuS der 3.–6. Klasse über ein Planspiel nähergebracht werden. In Rollenspielen lernen die Schülerinnen und Schüler die schwierigen Lebensumstände, Nahrungsmittelengpässe und die Diktatur in der DDR der 1950er Jahre kennen. Spielanleitungen, Arbeitsblätter und weitere Materialien helfen Ihnen, die Auseinandersetzung mit einer der wichtigsten Zäsuren der deutschen Nachkriegsgeschichte im Klassenzimmer vor- und nachzubereiten. Das Planspiel kann im Laufe eines Projekttages, einer Projektwoche oder auch im regulären Unterricht genutzt werden. Das Planspiel zum Download:',
        url: 'https://www.bundesstiftung-aufarbeitung.de/uploads/2013-pdf/capito_17juni_planspiel.pdf',
      },
      {
        type: 'pdf',
        body: 'Das Unterrichtsheft „Wir feiern die Einheit“ beinhaltet eine Lerneinheit für Grundschulen mit didaktischer Einführung und Arbeitsblättern, die die deutsche Teilungsgeschichte behandeln. Mauerbau, Alltag in der Diktatur und das Aufbegehren der DDR-Bevölkerung werden ebenso thematisiert wie die Friedliche Revolution und Deutsche Einheit. Enthalten ist zudem das Spiel „DIE MAUER MUSS WEG!“, geeignet für den Einsatz in Gruppen bzw. der Schulklasse. Das Unterrichtsmaterial zum Download:',
        url: 'https://www.bundesstiftung-aufarbeitung.de/uploads/pdf-2010/wirfeiern.pdf',
      },
      {
        type: 'pdf',
        body: '„Paul & Emilia auf Spurensuche – Ein Koffer voll Geschichte“ ist ein Comic mit begleitenden Unterrichtsimpulsen: Indem Paul und Emilia im Erinnerungsschatz ihrer Großeltern forschen, erhalten Schülerinnen und Schüler der Klassen 3 bis 6 einen altersgerechten Zugang zur DDR-Geschichte. Sie lernen das Alltagsleben der DDR kennen und werden mit den wichtigsten politischen Ereignissen der deutschen Teilungs- und Einheitsgeschichte vertraut gemacht. Das Unterrichtsmaterial und der Comic zum Download:',
        url: [
          'http://www.capito.de/fileadmin/capito/projekte_paedagogen/Bundesstiftung_Aufarbeitung/Paul-und-Emilia/capito_Paul-und-Emilia_Unterrichtsmaterial.pdf',
          'http://www.capito.de/fileadmin/capito/projekte_paedagogen/Bundesstiftung_Aufarbeitung/Paul-und-Emilia/capito_Paul-und-Emilia_Comic_komplett.pdf',
        ],
      },
    ],
  },
  {
    title: 'Exkursions-Tipps',
    items: [
      {
        body: 'Vielleicht gibt es die Möglichkeit, Grenzorte in Ihrer Umgebung zu besichtigen oder einen Besuch während einer mehrtägigen Klassenfahrt einzuplanen. Über Stichworte sind entsprechende Webseiten im Internet leicht aufzufinden, z. B. Harzer Grenzweg am „Grünen Band“ https://www.harzinfo.de/natur-pur/gruenes-band.html oder Ausflugsziele Harz http://www.ausflugsziele-harz.de/ausflugsziele-sehenswertes/wandern-biken/harzer-grenzweg.htm',
      },
      {
        body: 'In Berlin ist das Angebot für Klassenbesuche besonders reichhaltig. Hier bieten sich Besuche in der Gedenkstätte Berliner Mauer, im Mauermuseum am Checkpoint Charlie, im Tränenpalast oder im Notaufnahmelager Marienfelde an. Weitere Angebote finden sich auf dem Stadtportal oder in anderen Auflistungen:',
      },
      {
        type: 'link',
        body: 'Gedenkstätte Berliner Mauer',
        url: 'https://berliner-mauer-gedenkstaette.de/de/',
      },
      {
        type: 'link',
        body: 'Mauermuseum am Checkpoint Charlie',
        url: 'https://www.mauermuseum.de',
      },
      {
        type: 'link',
        body: 'Tränenpalast (der Stiftung Haus der Geschichte der Bundesrepublik Deutschland)',
        url: 'https://www.hdg.de/traenenpalast/ausstellung/',
      },
      {
        type: 'link',
        body: 'Mit aktuellen Veranstaltungstipps: Stadtportal Berlin',
        url: 'https://www.berlin.de/mauer/',
      },
      {
        type: 'link',
        body: 'Top10 Liste: Berliner Mauer – Orte',
        url: 'https://www.top10berlin.de/de/cat/freizeit-268/berliner-mauer-orte-745',
      },
    ],
  },
  {
    title: 'Literaturtipps',
    items: [
      {
        body: '„Anne Frank, die Mauer und ich. Zeitgeschichtliches Lernen zu Nationalsozialismus und DDR-Geschichte mit Kindern in Schule, Museum und Gedenkstätte“, Tagung der Bundeszentrale für Politische Bildung, der Humboldt-Universität zu Berlin und dem Anne Frank Zentrum, November 2015',
      },
      {
        body: 'Zu DDR-Geschichte und Geschichtsthemen im Sachunterricht, siehe verschiedene Ausgaben von http://www.widerstreit-sachunterricht.de, so beispielsweise von Monika Pape, „Geschichtsbewusstsein im Grundschulalter: Eine empirische Studie“, Ausgabe 11/Oktober 2008.',
      },
      {
        body: 'Kinderkrimi ab 10 Jahre: Ute Krause: Im Labyrinth der Lügen, München 2016.',
      },
      {
        body: 'Bände der Enquete-Kommission zur Aufarbeitung der SED-Diktatur https://enquete-online.de',
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/data/MORE_SOURCES.js